export enum RegistrationGaType {
  Amdea = 'AMDEA',
  Standard = 'STANDARD',
}
